module.exports = __webpack_public_path__ + "assets/img/cardItem05.9cdd1b8a.png";